import {
  LOADING_DATA_ON_PAGE_LOAD,
  BOARD_PAGE_NOT_FOUND
} from "../modules/savedItems/constants";
import { SET_ITEMS_TYPE } from "../modules/common/constants";
import { ITEMS_TYPE_SHARED_BOARD } from "../../constants";
import { getUserIdentity } from "../modules/identity/actions";

export const initialiseSharedBoardPageNotFound = () => async dispatch => {
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: true });
  dispatch({
    type: SET_ITEMS_TYPE,
    payload: { itemsType: ITEMS_TYPE_SHARED_BOARD }
  });
  dispatch({
    type: BOARD_PAGE_NOT_FOUND
  });
  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: false });
  dispatch(await getUserIdentity());
};
